import React from 'react';

export const DiscountBadge = () => (
  <div className="cart-popup__discount-badge discount-badge">
    <p>
      <b>Discount Auto-Applied!</b> You will get up to 30% off on your first month subscription
    </p>
  </div>
);
